import { User } from 'lib-shared-types-api';
import {
  getHighestUserRole,
  USER_ROLE_ATTRIBUTES,
  UserRoleAttributes,
} from 'lib-shared-user-role';

import { getUserDisplayName } from 'utils/user/getUserDisplayName';

export interface NormalizedUser {
  id: string;
  name: string;
  email?: string;
  additionalEmails?: string[];
  phone?: string;
  additionalPhoneNumbers?: string[];
  roleAttributes?: UserRoleAttributes;
}

export const normalizeUser = (user: User): NormalizedUser => {
  const {
    id,
    roles,
    email,
    phone_number,
    additional_emails,
    additional_phone_numbers,
  } = user;
  const highestRole = getHighestUserRole(roles ?? []);
  const userRole = USER_ROLE_ATTRIBUTES[highestRole];
  const normalizedName = getUserDisplayName(user);

  return {
    id: id,
    name: normalizedName,
    email: email ?? undefined,
    additionalEmails: additional_emails ?? [],
    phone: phone_number ?? undefined,
    additionalPhoneNumbers: additional_phone_numbers ?? [],
    roleAttributes: userRole,
  };
};
